import EditAsset from './EditAsset';

export default EditAsset;
